import authRules from '../authRules';

const addAssignmentEditActivityType = (user) => {
  const { activityType } = user.securityLevels;
  if (activityType >= authRules.addAssignmentEditActivityType.activityType) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentEditActivityType;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignmentEditActivityType.js